import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
const BackButton = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(false);
  const [showButton, setShowButton] = useState(false);
  // Only show back button if not on the homepage
  useEffect(() => {
    setShowButton(location.pathname !== '/');
  }, [location]);
  // Check if device is mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);
  const goBack = () => {
    navigate(-1);
  };
  if (!isMobile || !showButton) return null;
  return <button onClick={goBack} className="fixed left-4 bottom-20 z-40 bg-black/70 backdrop-blur-sm p-2 rounded-full border border-pink-500/30 hover:border-pink-500/60 transition-all shadow-lg shadow-pink-500/10 hover:shadow-pink-500/30" aria-label="Go back" data-id="element-54">
      <div className="relative w-8 h-8" data-id="element-55">
        {/* Spaceship body */}
        <div className="absolute inset-0 bg-gradient-to-br from-pink-500 to-purple-600 rounded-full transform rotate-45" data-id="element-56"></div>
        {/* Spaceship window */}
        <div className="absolute top-1.5 left-1.5 w-2 h-2 bg-blue-300 rounded-full" data-id="element-57"></div>
        {/* Engine flames */}
        <div className="absolute -right-1 top-1/2 w-3 h-1.5 bg-orange-500 rounded-l-full transform -translate-y-1/2 animate-pulse" data-id="element-58"></div>
        <div className="absolute -right-2 top-1/2 w-2 h-1 bg-yellow-400 rounded-l-full transform -translate-y-1/2 animate-pulse" style={{
        animationDelay: '0.2s'
      }} data-id="element-59"></div>
        {/* Direction indicator (left-pointing) */}
        <div className="absolute left-0 top-1/2 w-0 h-0 transform -translate-y-1/2 -translate-x-1/2 border-t-4 border-b-4 border-r-4 border-t-transparent border-b-transparent border-r-white" data-id="element-60"></div>
      </div>
    </button>;
};
export default BackButton;